/* Fire-pit option imagery is a temporary gallery view; native media and variants stay intact. */
(function () {
  'use strict';
  function safeUrl(value) {
    if (typeof value !== 'string' || !value.trim()) return '';
    try { var url = new URL(value, location.href); return url.protocol === 'https:' ? url.href : ''; }
    catch (_) { return ''; }
  }
  function finishCaption(name, description) {
    if (description && /AI color visualization|color preview/i.test(description)) return name + ' — Color preview. Actual handmade color and texture may vary.';
    if (description && /manufacturer|sample|swatch/i.test(description)) {
      return description.toLowerCase().indexOf(name.toLowerCase()) === 0 ? description : name + ' \u2014 ' + description;
    }
    return name + ' \u2014 Finish reference. ' + (description || 'Actual color and texture may vary.');
  }
  function prepareLightbox(main) {
    var lb = document.getElementById('ef-pd-lightbox');
    if (!lb) {
      lb = document.createElement('div'); lb.id = 'ef-pd-lightbox'; lb.className = 'ef-pd-lightbox';
      lb.setAttribute('data-ef-finish-lightbox', ''); document.body.appendChild(lb);
    }
    lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Product image');
    lb.setAttribute('aria-hidden', lb.classList.contains('ef-pd-lightbox--open') ? 'false' : 'true');
    function ensure(id, tag, className) {
      var el = document.getElementById(id);
      if (!el) { el = document.createElement(tag); el.id = id; el.className = className; lb.appendChild(el); }
      return el;
    }
    var close = ensure('ef-lb-close', 'button', 'ef-pd-lightbox__close');
    close.type = 'button'; close.setAttribute('aria-label', 'Close product image');
    if (!close.textContent.trim() && !close.children.length) close.textContent = '\u00d7';
    var img = ensure('ef-lb-img', 'img', 'ef-pd-lightbox__img'); img.alt = img.alt || '';
    ensure('ef-lb-counter', 'span', 'ef-pd-lightbox__counter');
    var lastFocus = null, wasOpen = false, htmlOverflow = '', bodyOverflow = '';
    function sync() {
      var open = lb.classList.contains('ef-pd-lightbox--open');
      lb.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open && !wasOpen) close.focus({ preventScroll: true });
      if (!open && wasOpen) {
        document.documentElement.style.overflow = htmlOverflow; document.body.style.overflow = bodyOverflow;
        if (lastFocus && lastFocus.isConnected) lastFocus.focus({ preventScroll: true });
      }
      wasOpen = open;
    }
    function closeDialog() {
      if (!lb.classList.contains('ef-pd-lightbox--open')) return;
      if (window.EFGallery && window.EFGallery.closeLightbox) window.EFGallery.closeLightbox();
      else lb.classList.remove('ef-pd-lightbox--open');
      sync();
    }
    document.addEventListener('click', function (event) {
      var zoom = event.target.closest && event.target.closest('#efGalleryZoom');
      if (!zoom || !main.contains(zoom) || lb.classList.contains('ef-pd-lightbox--open')) return;
      lastFocus = zoom;
      htmlOverflow = document.documentElement.style.overflow; bodyOverflow = document.body.style.overflow;
    }, true);
    close.addEventListener('click', closeDialog);
    lb.addEventListener('click', function (event) { if (event.target === lb) closeDialog(); });
    document.addEventListener('keydown', function (event) {
      if (!lb.classList.contains('ef-pd-lightbox--open')) return;
      if (event.key === 'Escape') { event.preventDefault(); closeDialog(); }
      if (event.key === 'Tab') {
        var focusable = Array.from(lb.querySelectorAll('button:not([disabled]),a[href],[tabindex="0"]')).filter(function (el) { return !el.hidden; });
        var first = focusable[0] || close, last = focusable[focusable.length - 1] || close;
        if (event.shiftKey && (document.activeElement === first || !lb.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (document.activeElement === last || !lb.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
      }
    });
    new MutationObserver(sync).observe(lb, { attributes: true, attributeFilter: ['class'] });
    return lb;
  }
  function bindFinishZoom(main, isPreviewActive, getSelected) {
    var lb = prepareLightbox(main);
    document.addEventListener('click', function (event) {
      var zoom = event.target.closest && event.target.closest('#efGalleryZoom');
      if (!zoom || !main.contains(zoom)) return;
      var g = window.EFGallery && window.EFGallery.main;
      if (!g || g.destroyed || g.el !== main || !window.EFGallery.openLightbox) return;
      var slide = main.querySelectorAll('.swiper-slide')[g.activeIndex];
      var img = slide && slide.querySelector('img');
      if (!img || slide.dataset.mediaType !== 'image') return;
      event.preventDefault();
      if (!lb.classList.contains('ef-pd-lightbox--open')) window.EFGallery.openLightbox(img.currentSrc || img.src, img.alt, g.activeIndex);
      var note = lb.querySelector('[data-ef-finish-lightbox-note]');
      if (!note) { note = document.createElement('p'); note.setAttribute('data-ef-finish-lightbox-note', ''); note.id = 'efFirepitLightboxNote'; lb.setAttribute('aria-describedby', note.id); note.style.cssText = 'position:absolute;bottom:24px;left:5%;right:5%;z-index:3;text-align:center;color:#fff;background:rgba(0,0,0,.75);padding:10px 16px;font-size:13px;line-height:1.5;'; lb.appendChild(note); }
      var selected = getSelected();
      note.hidden = !isPreviewActive(); note.textContent = isPreviewActive() && selected ? selected.caption : '';
    });
  }
  function bindSampleDialog(root, getSelected) {
    var dialog = document.createElement('dialog');
    dialog.className = 'ef-fp-sample-dialog';
    dialog.setAttribute('aria-labelledby', 'efFpSampleTitle');
    dialog.setAttribute('aria-describedby', 'efFpSampleNote');
    dialog.innerHTML = '<div class="ef-fp-sample-dialog__head"><h2 id="efFpSampleTitle"></h2><button type="button" aria-label="Close color sample">\u00d7</button></div><img alt=""><p id="efFpSampleNote">Manufacturer color sample. Screen settings and handmade finishes can affect how the color appears.</p>';
    document.body.appendChild(dialog);
    var title = dialog.querySelector('h2'), image = dialog.querySelector('img'), close = dialog.querySelector('button'), opener = null, overflow = '';
    function dismiss() { if (dialog.open) dialog.close(); }
    close.addEventListener('click', dismiss);
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dismiss();
    });
    dialog.addEventListener('close', function () {
      document.documentElement.style.overflow = overflow;
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    });
    root.addEventListener('click', function (event) {
      var link = event.target.closest('a');
      if (!link || !/View manufacturer color sample/i.test(link.textContent)) return;
      var url = safeUrl(link.href), selected = getSelected();
      if (!url || !selected || !dialog.showModal) return;
      event.preventDefault();
      opener = link; title.textContent = selected.name; image.alt = selected.name + ' — manufacturer color sample';
      image.src = url;
      overflow = document.documentElement.style.overflow;
      dialog.showModal(); document.documentElement.style.overflow = 'hidden'; close.focus();
    });
  }
  function init() {
    var root = document.querySelector('[data-ef-native-firepit]');
    var main = document.getElementById('efGallerySwiper');
    if (!root || !main || main._efFinishPreview) return;
    main._efFinishPreview = true;
    var wrapper = main.querySelector('.swiper-wrapper');
    if (!wrapper) return;
    var thumbs = document.getElementById('efGalleryThumbs');
    var thumbWrapper = thumbs && thumbs.querySelector('.swiper-wrapper');
    var caption = document.createElement('div');
    caption.className = 'ef-firepit-finish-preview-note'; caption.hidden = true;
    caption.setAttribute('data-ef-finish-preview-note', '');
    var message = document.createElement('p');
    message.setAttribute('role', 'status'); message.setAttribute('aria-live', 'polite');
    var actions = document.createElement('div');
    actions.className = 'ef-firepit-finish-preview-actions';
    var toggle = document.createElement('button'); toggle.type = 'button';
    var sample = document.createElement('a'); sample.target = '_blank'; sample.rel = 'noopener noreferrer';
    sample.textContent = 'View manufacturer color sample'; sample.hidden = true;
    actions.append(toggle, sample); caption.append(message, actions);
    main.insertAdjacentElement('afterend', caption);
    var style = document.createElement('style');
    style.textContent = '.ef-firepit-finish-preview-note{font:inherit;font-size:13px;line-height:1.5;color:var(--ef-text-muted,#625e57);margin:10px 0 14px}.ef-firepit-finish-preview-note p{margin:0 0 6px}.ef-firepit-finish-preview-actions{display:flex;flex-wrap:wrap;gap:8px 16px}.ef-firepit-finish-preview-actions button{font:inherit;color:inherit;background:none;border:0;padding:4px 0;cursor:pointer;text-decoration:underline;text-underline-offset:3px}.ef-firepit-finish-preview-actions a{color:inherit;text-decoration:underline;text-underline-offset:3px}.ef-firepit-finish-preview-actions [hidden]{display:none!important}#efGallerySwiper [data-ef-finish-preview] img{width:100%;height:100%;object-fit:contain;background:#fff}#efGalleryThumbs [data-ef-finish-preview] img{object-fit:contain}[data-ef-finish-lightbox]{position:fixed;inset:0;width:100%;height:100dvh;box-sizing:border-box;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:64px 20px 110px;background:rgba(0,0,0,.92);opacity:0;visibility:hidden;pointer-events:none}[data-ef-finish-lightbox].ef-pd-lightbox--open{opacity:1;visibility:visible;pointer-events:auto}[data-ef-finish-lightbox] #ef-lb-img{max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain}[data-ef-finish-lightbox] #ef-lb-close{position:absolute;right:16px;top:16px;width:44px;height:44px;border:1px solid #fff;border-radius:50%;background:#222;color:#fff;font-size:28px;cursor:pointer}[data-ef-finish-lightbox] #ef-lb-counter{position:absolute;left:20px;top:24px;bottom:auto;transform:none;color:#fff}[data-ef-finish-lightbox] [data-ef-finish-lightbox-note]{max-height:80px;overflow:auto}';
    document.head.appendChild(style);
    var token = 0, currentKey = '', preview = null, previewThumb = null, selected = null;
    var status = 'idle', attachedGallery = null, refreshFrame = 0;
    function gallery() {
      var g = window.EFGallery && window.EFGallery.main;
      return g && !g.destroyed && g.el === main ? g : null;
    }
    function slides() { return Array.from(wrapper.children).filter(function (node) { return node.classList.contains('swiper-slide'); }); }
    function isPreviewActive() { var g = gallery(); return !!(g && preview && slides()[g.activeIndex] === preview); }
    function syncCounter() {
      var counter = document.getElementById('ef-pd-counter');
      var cur = document.getElementById('ef-pd-counter-cur');
      var g = gallery();
      if (counter && cur) { cur.textContent = String((g ? g.activeIndex : 0) + 1); while(cur.nextSibling) cur.nextSibling.remove(); counter.appendChild(document.createTextNode(' / ' + slides().length)); }
    }
    function syncCaption() {
      var active = isPreviewActive();
      if (!selected) { caption.hidden = true; return; }
      caption.hidden = false;
      if (status === 'loading') message.textContent = selected.name + ' — loading finish reference.';
      else if (status === 'missing' || status === 'error') message.textContent = selected.name + ' — ' + (status === 'error' ? 'the finish image could not be loaded.' : 'a verified finish image is not available.') + ' Original product photo shown; it may show a different finish.';
      else if (active) message.textContent = selected.caption;
      else message.textContent = 'Original product gallery. Selected finish: ' + selected.name + '. The finish in this photo may differ.';
      toggle.hidden = !preview || status !== 'ready';
      toggle.textContent = active ? 'View original product photos' : 'View selected finish';
      sample.hidden = !selected.sample;
      if (selected.sample) sample.href = selected.sample; else sample.removeAttribute('href');
      syncCounter();
    }
    function updateGallery() {
      var g = gallery();
      if (!g) return;
      g.update();
      var t = window.EFGallery && window.EFGallery.thumbs;
      if (t && !t.destroyed) t.update();
      if (g.thumbs && g.thumbs.update) g.thumbs.update();
      syncCounter();
    }
    function removePreview() {
      var g = gallery();
      if (window.EFGallery && window.EFGallery.closeLightbox && preview) window.EFGallery.closeLightbox();
      if (g && isPreviewActive()) g.slideTo(0, 0);
      if (preview) preview.remove(); if (previewThumb) previewThumb.remove();
      preview = null; previewThumb = null;
      updateGallery();
    }
    function readSelection() {
      var group = root.querySelector('.ef-uni-variant-group[data-axis-type="color"][data-axis-name]');
      if (!group) return null;
      var active = group.querySelector('[data-variant-option].is-active, [data-variant-option][aria-checked="true"]');
      var select = group.querySelector('.ef-uni-variant-select');
      var name = active ? active.dataset.variantOption : select && select.value;
      if (!name) return null;
      var data = {}; try { data = JSON.parse(document.getElementById('efFirepitOptionMedia').textContent) || {}; } catch (_) {}
      var entry = data[group.dataset.axisName] && data[group.dataset.axisName][name] || {};
      // Legacy material samples are not whole-product previews. Require explicit verification.
      var url = entry.fullProductPreview === true ? (safeUrl(entry.imageFull) || safeUrl(entry.image)) : '';
      var description = typeof entry.description === 'string' ? entry.description : '';
      var sampleUrl = safeUrl(entry.sampleImage) || (/manufacturer.*(?:sample|swatch)|material finish sample/i.test(description) ? safeUrl(entry.image) : '');
      var caption = !url && sampleUrl ? name + ' — Manufacturer finish sample. Actual handmade color and texture may vary.' : finishCaption(name, description);
      return { name: name, url: url, sample: sampleUrl, caption: caption, key: JSON.stringify([group.dataset.axisName, name, url, entry.description, sampleUrl]) };
    }
    function refresh(force) {
      var next = readSelection();
      if (!force && next && next.key === currentKey) { var currentGallery = gallery(); if (preview && currentGallery) currentGallery.slideTo(slides().indexOf(preview), 0); syncCaption(); return; }
      currentKey = next ? next.key : ''; selected = next;
      var request = ++token; removePreview();
      if (!next) { syncCaption(); return; }
      if (!next.url) { status = 'missing'; var g = gallery(); if (g) g.slideTo(0, 0); syncCaption(); return; }
      status = 'loading'; syncCaption();
      var image = new Image();
      image.onload = function () {
        if (request !== token || !main.isConnected) return;
        var g = gallery(); if (!g) { status = 'error'; syncCaption(); return; }
        preview = document.createElement('div'); preview.className = 'swiper-slide ef-pd-slide';
        preview.setAttribute('data-ef-finish-preview', ''); preview.dataset.mediaType = 'image';
        image.alt = next.caption; image.decoding = 'async'; image.loading = 'eager';
        image.width = image.naturalWidth; image.height = image.naturalHeight;
        preview.appendChild(image); wrapper.appendChild(preview);
        if (thumbWrapper) {
          previewThumb = document.createElement('div'); previewThumb.className = 'swiper-slide ef-pd-thumb';
          previewThumb.setAttribute('data-ef-finish-preview', ''); previewThumb.dataset.mediaType = 'image';
          previewThumb.setAttribute('role', 'button'); previewThumb.tabIndex = 0; previewThumb.setAttribute('aria-label', 'View ' + next.name + ' finish reference');
          var thumbImage = document.createElement('img'); thumbImage.src = next.url; thumbImage.alt = next.name + ' finish reference'; thumbImage.width = 200; thumbImage.height = 200;
          previewThumb.appendChild(thumbImage); thumbWrapper.appendChild(previewThumb);
          previewThumb.addEventListener('keydown', function (event) { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); g.slideTo(slides().indexOf(preview), 0); } });
        }
        status = 'ready'; updateGallery(); g.slideTo(slides().indexOf(preview), 0); syncCaption();
      };
      image.onerror = function () { if (request !== token) return; removePreview(); status = 'error'; var g = gallery(); if(g) g.slideTo(0, 0); syncCaption(); };
      image.src = next.url;
    }
    function queueRefresh(force) { if (refreshFrame) cancelAnimationFrame(refreshFrame); refreshFrame = requestAnimationFrame(function () { refreshFrame = 0; refresh(force); }); }
    bindFinishZoom(main, isPreviewActive, function () { return selected; });
    bindSampleDialog(root, function () { return selected; });
    toggle.addEventListener('click', function () { var g = gallery(); if (!g || !preview) return; g.slideTo(isPreviewActive() ? 0 : slides().indexOf(preview), 0); syncCaption(); });
    root.addEventListener('click', function (event) { if (event.target.closest('[data-axis-type="color"] [data-variant-option]')) queueRefresh(false); });
    root.addEventListener('change', function (event) { if (event.target.closest('[data-axis-type="color"] .ef-uni-variant-select')) queueRefresh(false); });
    document.addEventListener('ef:firepit-product-change', function () { queueRefresh(true); });
    var attempts = 0;
    function attach() {
      var g = gallery();
      if (!g) { if (++attempts < 80) window.setTimeout(attach, 100); return; }
      if (attachedGallery !== g) { attachedGallery = g; g.on('slideChange', syncCaption); }
      refresh(true);
    }
    attach();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
